import { WDJSErrorHandler } from 'wd-js-error-handler';
    const FP = window.flatpickr;
    class WDRegisterForm extends HTMLElement {
        static selectors = {
            firstNameInput: 'input[name="firstName"]',
            firstNameErrorMessage: '#firstNameErrorMessage',
            lastNameInput: 'input[name="lastName"]',
            lastNameErrorMessage: '#lastNameErrorMessage',
            phoneInput: 'input[name="phone"]',
            phoneErrorMessage: '#phoneErrorMessage',
            emailInput: 'input[name="email"]',
            emailErrorMessage: '#emailRegisterErrorMessage',
            isClubMemberCheckbox: 'input[name="isClubMember"]',
            isTermsApprovedCheckbox: 'input#terms[name="terms"]',
            submitButton: '.wd-register-submit',
            generalErrorMessage: '#generalRegisterErrorMessage',
            loader: '#loader',
            genderFieldset: '.fieldset-gender',
        };


        constructor() {
            super();
            this.err = new WDJSErrorHandler();
            this.attachEventListeners();
        }


        attachEventListeners() {
            this.querySelector(WDRegisterForm.selectors.submitButton)?.addEventListener('click', this.handleSubmit);
            // Add Enter key support for form inputs
            const inputs = [
                WDRegisterForm.selectors.firstNameInput,
                WDRegisterForm.selectors.lastNameInput,
                WDRegisterForm.selectors.phoneInput,
                WDRegisterForm.selectors.emailInput,
            ];
            
            inputs.forEach(selector => {
                const input = this.querySelector(selector);
                if (input) {
                    input.addEventListener('keydown', (e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            this.handleSubmit(e);
                        }
                    });
                }
            });
        }



        handleSubmit = async (event) => {
            if (!this.isValid()) return;

            const requestData = this.getRequestData();
            try {

                const response = await this.sendRequest('/apps/api/customers/', "POST", requestData);
                if (response.success) {
                    console.log("Registration successful:", response);
                    window.location.href = response.data || '/'; // Redirect to the specified URL or home page
                }
            } catch (error) {
                this.displayError("אירעה שגיאה במהלך ההרשמה. אנא נסה שוב.");
            }
        };


        async sendRequest(url, method, data = null) {
            try {
                const response = await fetch(`${window.location.origin}${url}`, {
                    method: method,
                    headers: { 'Content-Type': 'application/json' },
                    ...(data ? { body: JSON.stringify(data) } : {})
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    console.error("Error response from server:", errorData);
                    this.displayError(this.err.frontendError(errorData.message[0]) || "אירעה שגיאה, נסה שוב מאוחר יותר.");
                    return { success: false };
                }
                return await response.json();
            } catch (error) {
                console.error("Error during API call:", error);
                this.displayError("אירעה שגיאה במהלך שליחת בקשה. אנא נסה שוב.");
                return { success: false };
            }
        }

        getRequestData() {
            const isClubMember = this.querySelector(WDRegisterForm.selectors.isClubMemberCheckbox).checked;
            const commonData = {
                firstName: this.querySelector(WDRegisterForm.selectors.firstNameInput).value,
                lastName: this.querySelector(WDRegisterForm.selectors.lastNameInput).value,
                phone: this.querySelector(WDRegisterForm.selectors.phoneInput).value,
                email: this.querySelector(WDRegisterForm.selectors.emailInput).value,
                isClubMember
            };

            if (isClubMember) {
                return {
                    ...commonData,
                    isNewsLetterApproved: isClubMember, // Newsletter approval is now tied to club membership
                };
            }

            return commonData;
        }

        isValid() {
            let valid = true;
            this.clearErrorMessages();

            valid &= this.validateInput(WDRegisterForm.selectors.firstNameInput, WDRegisterForm.selectors.firstNameErrorMessage, "נא הקלד את השם הפרטי שלך");
            valid &= this.validateInput(WDRegisterForm.selectors.lastNameInput, WDRegisterForm.selectors.lastNameErrorMessage, "נא הקלד את שם המשפחה שלך");
            valid &= this.validateInput(WDRegisterForm.selectors.phoneInput, WDRegisterForm.selectors.phoneErrorMessage, "נא הקלד טלפון תקין", /^\d{10}$/);
            valid &= this.validateInput(WDRegisterForm.selectors.emailInput, WDRegisterForm.selectors.emailErrorMessage, "נא הקלד מייל תקין", /^[^\s@]+@[^\s@]+\.[^\s@]+$/);



            if (!this.querySelector(WDRegisterForm.selectors.isTermsApprovedCheckbox).checked) {
                this.displayError("עליך לאשר את תנאי השימוש כדי להמשיך");
                return false;
            }else{
                this.clearErrorMessages();
            }


            return valid;
        }

        validateInput(inputSelector, errorMessageSelector, errorText, regex = null) {
            const inputElement = this.querySelector(inputSelector);
            const errorElement = this.querySelector(errorMessageSelector);
            const labelELement = inputElement.closest('label') || inputElement.previousElementSibling; // Get the label element

            if (!inputElement.value || (regex && !regex.test(inputElement.value))) {
                this.showError(inputElement, errorElement,labelELement, errorText);
                return false;
            }

            this.clearInputError(inputElement, errorElement,labelELement);
            return true;
        }




        showError(inputElement, errorElement,labelELement, errorText) {
            errorElement.textContent = errorText;
            errorElement.style.display = 'block';
            inputElement.style.border = '1px solid #C53120';
            inputElement.style.color = '#C53120';
            inputElement.style.backgroundColor = 'rgba(233, 79, 61, 0.15)';
            if(labelELement){
                labelELement.style.color = '#C53120'; // Change label color to red
            }
        }

        clearInputError(inputElement, errorElement,labelElement) {
            errorElement.style.display = 'none';
            inputElement.style.border = '';
            inputElement.style.color = '';
            inputElement.style.backgroundColor = '';
            if(labelElement){
                labelElement.style.color = ''; // Reset label color
            }
        }

        clearErrorMessages() {
            const errorMessages = [
                WDRegisterForm.selectors.generalErrorMessage,
            ];

            errorMessages.forEach(selector => {
                const errorMessage = this.querySelector(selector);
                if (errorMessage) errorMessage.style.display = 'none';
            });
        }

        displayError(message) {
            const errorMessage = this.querySelector(WDRegisterForm.selectors.generalErrorMessage);
            errorMessage.textContent = message;
            errorMessage.style.display = 'block';
        }

        // Add inside the class
        toISODate(dmy) {
            if (!dmy) return '';
            // already ISO?
            if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(dmy)) return dmy;

            const m = dmy.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
            if (!m) return '';
            const [, d, mth, y] = m;
            // Pad month and day with leading zeros to ensure 2-digit format
            return `${y}-${mth.padStart(2, '0')}-${d.padStart(2, '0')}`;
        }

    }

    window.addEventListener('load', () => {
        customElements.define('wd-register-form', WDRegisterForm);
    });
